/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: mqAYXqPyOASe
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicInputFormShell.module.css"; // plasmic-import: mqAYXqPyOASe/css

createPlasmicElementProxy;

export const PlasmicInputFormShell__VariantProps = new Array("layout");

export const PlasmicInputFormShell__ArgProps = new Array(
  "fieldsSlot",
  "actionsSlot"
);

const $$ = {};

function PlasmicInputFormShell__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layout",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.layout
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"theActuallyShell"}
      data-plasmic-override={overrides.theActuallyShell}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.theActuallyShell,
        {
          [sty.theActuallyShelllayout__default]: hasVariant(
            $state,
            "layout",
            "_default"
          ),
          [sty.theActuallyShelllayout_oneBox]: hasVariant(
            $state,
            "layout",
            "oneBox"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"fields"}
        data-plasmic-override={overrides.fields}
        className={classNames(projectcss.all, sty.fields, {
          [sty.fieldslayout_oneBox]: hasVariant($state, "layout", "oneBox")
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.fieldsSlot
        })}
      </div>
      <div
        data-plasmic-name={"actions"}
        data-plasmic-override={overrides.actions}
        className={classNames(projectcss.all, sty.actions, {
          [sty.actionslayout_oneBox]: hasVariant($state, "layout", "oneBox")
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.actionsSlot
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  theActuallyShell: ["theActuallyShell", "fields", "actions"],
  fields: ["fields"],
  actions: ["actions"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInputFormShell__ArgProps,
          internalVariantPropNames: PlasmicInputFormShell__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInputFormShell__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "theActuallyShell") {
    func.displayName = "PlasmicInputFormShell";
  } else {
    func.displayName = `PlasmicInputFormShell.${nodeName}`;
  }
  return func;
}

export const PlasmicInputFormShell = Object.assign(
  // Top-level PlasmicInputFormShell renders the root element
  makeNodeComponent("theActuallyShell"),
  {
    // Helper components rendering sub-elements
    fields: makeNodeComponent("fields"),
    actions: makeNodeComponent("actions"),
    // Metadata about props expected for PlasmicInputFormShell
    internalVariantProps: PlasmicInputFormShell__VariantProps,
    internalArgProps: PlasmicInputFormShell__ArgProps
  }
);

export default PlasmicInputFormShell;
/* prettier-ignore-end */
